module.exports = __webpack_public_path__ + "static/img/back02.950b458.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back02.png
// module id = mFiK
// module chunks = 1